import storage from '/src/utils/storage';

export const getStorageParamForCurrentCompany = (key) => storage('local').get(`company_${storage('session').get('company').id}_${key}`) ?? {};

export const removeStorageParamForCurrentCompany = (key) => storage('local').remove(`company_${storage('session').get('company').id}_${key}`);

export const setStorageParamForCurrentCompany = (key, value = {}) => storage('local').set(`company_${storage('session').get('company').id}_${key}`, value);